import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { MessageSquare, Layers, Moon } from "lucide-react";
import dashboard2 from "@/assets/analytics-dashboard-2.png";
import { Badge } from "@/components/ui/badge";

const dataPoints = [
  { icon: MessageSquare, label: "Top-Anfragethemen & Volumen", color: "text-chathero-mint" },
  { icon: Layers, label: "Cluster nach Kanal", color: "text-chathero-orange" },
  { icon: Moon, label: "Nutzung nach Tageszeit", color: "text-primary" },
];

const benefits = [
  "Besseres Kampagnen-Timing",
  "Optimierte Ressourcenplanung",
  "Strategische Content-Priorisierung",
];

const AnalyticsNachfrageSection = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className={cn(
        "py-16 md:py-24 bg-secondary/20 transition-all duration-700 ease-out",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      )}
    >
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Dashboard Screenshot */}
          <div className="rounded-2xl overflow-hidden shadow-2xl border border-border order-last lg:order-first">
            <img
              src={dashboard2}
              alt="Chathero AI Analytics – Top-Anfragethemen und Nutzeraktivität nach Tageszeit"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>

          <div>
            <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">Nachfrage</Badge>
            <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
              Nachfrage & Verhalten verstehen
            </h2>
            <p className="text-lg text-muted-foreground mb-6">
              AI Analytics macht Nachfragemuster sichtbar – nach Thema, Kanal und Tageszeit. Ihre AI wird zur Echtzeit-Marktanalyse.
            </p>

            <div className="space-y-3 mb-8">
              {dataPoints.map((point, i) => (
                <div key={i} className="flex items-center gap-3 p-3 rounded-xl bg-card border border-border shadow-sm">
                  <point.icon className={cn("w-5 h-5 shrink-0", point.color)} />
                  <span className="text-sm text-foreground">{point.label}</span>
                </div>
              ))}
            </div>

            <div className="bg-card border border-border rounded-2xl p-6 shadow-sm">
              <h3 className="font-semibold text-foreground mb-4">Diese Daten ermöglichen:</h3>
              <div className="space-y-3">
                {benefits.map((b, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-chathero-mint shrink-0" />
                    <span className="text-muted-foreground">{b}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnalyticsNachfrageSection;
